import {EventsPermissions, LprPermissions} from 'src/common/utils/PermissionsList'

import {isMigratedLegacyPath} from './is-migrated-legacy-path'
import {normalizeNavPath} from './normalize-nav-path'
import {isNewPortalEnabledForPath} from './portal-module-prefs'
import {readPortalModulePrefsFromClientCookie} from './portal-module-prefs.client'

function hasEventsPermission(userPermissions: string[]) {
  return EventsPermissions.every((permission) => userPermissions.includes(permission.name))
}

function hasLprPermission(userPermissions: string[]) {
  return LprPermissions.every((permission) => userPermissions.includes(permission.name))
}

export function canUseNewPortalChangePassword(userPermissions: string[]) {
  return hasEventsPermission(userPermissions) || hasLprPermission(userPermissions)
}

function pickLegacyPathWithNewPortalView(candidates: string[]) {
  const prefs = readPortalModulePrefsFromClientCookie()
  const unique = Array.from(new Set(candidates))

  for (const path of unique) {
    if (isNewPortalEnabledForPath(path, prefs)) return path
  }

  return null
}

export function resolveChangePasswordLegacyPath(pathname: string, userPermissions: string[]) {
  const hasEvents = hasEventsPermission(userPermissions)
  const hasLpr = hasLprPermission(userPermissions)
  const candidates: string[] = []

  if (isMigratedLegacyPath(pathname)) {
    const normalized = normalizeNavPath(pathname)
    if (normalized === '/events' && hasEvents) candidates.push('/events')
    if (normalized === '/license-plate' && hasLpr) candidates.push('/license-plate')
  }

  if (hasEvents) candidates.push('/events')
  if (hasLpr) candidates.push('/license-plate')

  return pickLegacyPathWithNewPortalView(candidates)
}
